// XXX: do not keep this helper
// this a temporary function until backend is able to filter orn the context (T72257)
// Temporary fix to prevent applying unusable template (T72202)
const UNUSABLE = {
  transfer: ['7de9e594-df99-11e9-b037-00163e7504b8',
  // Gandi Migration to LiveDNS (stage)
  '7e358eb4-e13c-11e9-9b2f-00163e544dad' // Gandi Migration to LiveDNS
  ],
  create: ['7de9e594-df99-11e9-b037-00163e7504b8',
  // Gandi Migration to LiveDNS (stage)
  '7e358eb4-e13c-11e9-9b2f-00163e544dad',
  // Gandi Migration to LiveDNS
  '76d9db1e-1557-11e8-a425-00163e2ddf00',
  // No change to the configuration (stage)
  '04e7c5e8-2213-11e8-8690-00163e1c85a5' // No change to the configuration
  ],
  created: ['76d9db1e-1557-11e8-a425-00163e2ddf00',
  // No change to the configuration(stage)
  '04e7c5e8-2213-11e8-8690-00163e1c85a5' // No change to the configuration
  ]
};
export const isUsableInContext = (templateId, context) => !UNUSABLE[context].includes(templateId);